const btn = document.querySelector(".or__header__btn");
const menu = document.querySelector(".hamburger__menu");
const header = document.querySelector(".or__header");
const closeBtn = document.querySelector(".hamburger__menu--close");

if (btn && menu && header) {
  // 開閉ボタン
  btn.addEventListener("click", () => {
    menu.classList.toggle("active");
    header.classList.toggle("active");
    btn.classList.toggle("open");
  });

  // 閉じるボタン
  if (closeBtn) {
    closeBtn.addEventListener("click", () => {
      menu.classList.remove("active");
      header.classList.remove("active");
      btn.classList.remove("open");
    });
  }
}



    // modal
    document.addEventListener('DOMContentLoaded', function () {
      document.querySelectorAll('.js-modalOpen').forEach(function (element) {
        element.addEventListener('click', function (event) {
          event.preventDefault();
          const target = this.dataset.modaltarget;
          const modal = document.getElementById(target);
          if (modal) {
            modal.classList.add('is-visible');
          }
        });
      });
      document.querySelectorAll('.js-modalClose').forEach(function (element) {
        element.addEventListener('click', function (event) {
          event.preventDefault();
          document.querySelectorAll('.js-modal').forEach(function (modal) {
            modal.classList.remove('is-visible');
          });
        });
      });
    });